import {Card} from '@models/card';
import {EquipmentCardEnums, EquipmentCardInterfaces} from '@namespaces/equipment.namespace';
import {Calibration} from '@models/card/calibration';

export class WizardCardPreview extends Card {
    public info: string;
    public calibrationErrorMessage: string;
    public calibrationErrorPopover: string;
    public hasFutureCalibration: boolean;

    /**
     * Оборудования находится в работе
     */
    public isWorkingStatus: boolean;

    constructor(
        _rawData: EquipmentCardInterfaces.Card.ItemView
    ) {
        super(_rawData);
    }

    protected setAttributes() {
        super.setAttributes();

        const info: string[] = [];

        if (this.rawData.is_calibrated && (this.calibration || this.emptyCalibrationMessage)) {
            info.push('');
        }

        info.push(this.serial);
        info.push(this.year.toString());

        this.info = info.join(' · ');

        const noActualCalibration = this.rawData.is_calibrated && (!this.calibration || this.calibration.isExpired);

        this.calibrationErrorMessage = noActualCalibration ?
            `Добавьте сведения об актуальной ${Calibration.getCalibrationLabel(
                this.rawData.apparatus.verification_status,
                'поверке',
                'калибровке',
                'поверке/калибровке'
                )}` :
            null;

        this.calibrationErrorPopover = noActualCalibration ?
            `Оборудование должно быть обязательно ${Calibration.getCalibrationLabel(
                this.rawData.apparatus.verification_status,
                'поверено',
                'откалибровано',
                'поверено/откалибровано'
            )}, сведения о ${Calibration.getCalibrationLabel(
                this.rawData.apparatus.verification_status,
                'поверке',
                'калибровке',
                'поверке/калибровке'
            )} должны перекрывать текущую дату` :
            null;

        this.hasFutureCalibration = this.rawData.has_future_calibration;

        this.isWorkingStatus = this.rawData.status === EquipmentCardEnums.EquipmentStatus.working;
    }
}
